module.exports = __webpack_public_path__ + "img/FM.387173bb.svg";